import type { PsyFiVault, TulipVault, VaultPosition } from "@stepfinance/vaults";

export const isTulipVault = (v: VaultPosition): v is TulipVault => {
  return v.platform === "Tulip" || "harvest" in v;
};

export const isPsyFiVault = (v: VaultPosition): v is PsyFiVault => {
  return v.platform === "PsyFi";
};
